import { createApp } from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import mitt from 'mitt';
import axios from "axios";
import "vue-multiselect/dist/vue-multiselect.css";
import Toast, { PluginOptions } from "vue-toastification";
import "vue-toastification/dist/index.css";
import { useToast } from "vue-toastification";
import VueApexCharts from "vue3-apexcharts";

import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';

import 'primeicons/primeicons.css';

import "../src/index.css"; // Ensure this path is correct
export const toast = useToast();
export const emitter = mitt();

const instance = axios.create({
    withCredentials: true,
});

instance.interceptors.request.use(
    function(config) {
        const token = localStorage.getItem('AUTH_ID');
        const appId = 10007;
        if (token) {
            // Ensure headers are correctly initialized
            config.headers = config.headers || {};
            config.headers.common = config.headers.common || {};
            config.headers.common["Authorization"] = 'Bearer ' + token;  
            config.headers.Authorization = 'Bearer ' + token; 
            config.headers['App-Id'] = appId; 
              
        }
        return config;
    }, 
    function(err) {
        return Promise.reject(err);
    }
);
instance.interceptors.response.use((response) => {
    return response;
  }, (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('authToken'); 
      // window.location.href = "http://localhost:8080"; 
      window.location.href = `${process.env.VUE_APP_AUTH_UI}/?returnTo=${process.env.VUE_APP_PLANNER_UI}`
    }
  //  if (error.response?.status === 403) {
  //     router.replace({ name: 'error', query: { code: '403' } });
  //     return new Promise(() => {});
  //   }
    // if (error.response?.status === 403) {
    //   // Optionally, clear any global page data first
    //   store.commit('CLEAR_PAGE_DATA'); // or similar
    //   // Redirect immediately
    //   router.replace({ name: 'error', query: { code: '403' } });
    //   // Return a never-resolving promise to prevent component API usage
    //   return new Promise(() => {});
    // }
  });

const app = createApp(App);

app.config.globalProperties.$http = instance;
app.use(router);
app.use(store);
app.use(Toast);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: { darkModeSelector: '.my-app-dark'},
}})
// app.use(VueApexCharts);
app.mount('#app');
